import React, {useState, useEffect, useRef} from 'react'
import {
  Button,
  Icon,
  ParagraphText,
  // Select,
  SolidAltArrowLeft,
  SolidAltArrowRight,
} from '@thryvlabs/maverick'
import dayjs from 'dayjs'
import {Spinner} from '../loader-spinner'
import {toast} from 'react-toastify'
import {kP11LinkService} from '../keap-partner/kp-11-link/kp-11Link-utility/kp11-service'
import {getKickoffCallLabelFromCart} from '../keap-partner/kp-11-link/kp-11Link-utility/kp11-utility'
import {useAuthClient} from '../../utils/use-auth-client'
import {useDispatch, useSelector} from 'react-redux'
import {selectAddonCodeMap} from '../../app-store/productRules/productRulesSlice'
import {fetchProductGroups} from '../../app-store/productRules/productRulesThunk'
import {selectedLinkType} from '../../app-store/kpGlobalStateSlice'
import {
  NEW_THRYV_LEAD_CODE,
  NEW_THRYV_LEAD_TAX_CODE,
} from '../../utils/constants'
import {useUserFeatures} from '../../context/user-features-context'
const SCHEDULE_ROW_COUNT = 4
const SLOT_BTN_WIDTH = 80
// const minDay = 0
// const maxDayRange = 14
let timeZones = [
  {name: 'Hawaii', value: 'Pacific/Honolulu'},
  {name: 'Alaska', value: 'America/Juneau'},
  {name: 'Pacific Time (US & Canada)', value: 'America/Los_Angeles'},
  {name: 'Arizona Time', value: 'America/Phoenix'},
  {name: 'Mountain Time (US & Canada)', value: 'America/Denver'},
  {name: 'Central Time (US & Canada)', value: 'America/Chicago'},
  {name: 'Eastern Time (US & Canada)', value: 'America/New_York'},
  {name: 'Eastern Time (Canada)', value: 'America/Toronto'},
  {name: 'Atlantic Time (Canada)', value: 'America/Halifax'},
  {name: 'Newfoundland Time (Canada)', value: 'America/St_Johns'},
]
timeZones = timeZones.map(item => {
  return {
    name: `${dayjs().utc().tz(item.value).format('Z')} ${item.name}`,
    value: item.value,
  }
})

const DEFAULT_TIMEZONE = timeZones.find(
  item => item.value === 'America/Chicago',
)

let SCHEDULE_OPTIONS = []

export const SchedulerAppointmentComponent = ({
  isCreativeCallExist,
  isKickOffCallExist,
  scheduleKickOffCallDetails,
  setScheduledKickOffCallDetails,
  scheduleCreativeCallDetails,
  setScheduledCreativeCallDetails,
  handleScheduleSuccessStatus,
  handleSkipScheduling,
  accountInformation,
  selectedCountry = 'US',
  transitionData,
  structuredCart,
}) => {
  const dispatch = useDispatch()
  const slotTargetRef = useRef(null)
  const [selectTimeZone, setSelectedTimeZone] = useState(DEFAULT_TIMEZONE)
  const [selectedHours, setSelectedHours] = useState(null)
  const [selectedDate, setSelectedDate] = useState(null)
  const [isLoading, setLoadingStatus] = useState(false)
  // const [minDate, setMinDate] = useState(dayjs())
  // const [maxDate, setMaxDate] = useState(dayjs())
  const [isConfirmationInitiated, setConfirmationInitiatedStatus] =
    useState(false)
  const [selectedMonth, setSelectedMonth] = useState(
    dayjs().format('MMMM[,] YYYY'),
  )
  const [availableSlotDetails, setAvailableSlotDetails] = useState({
    availableTimes: [],
    serviceIdTitle: {},
    timeZone: {},
  })
  const [selectedCall, setSelectedCall] = useState('')

  const [seoDetail, setSeoDetail] = useState(null)
  const [scheduleOffsetDetails, setScheduleOffsetDetails] = useState([])
  const currentSlotScrollPosition = useRef(0)
  const currentDateScrollPosition = useRef(0)
  const client = useAuthClient()
  const addonCodeMap = useSelector(selectAddonCodeMap)
  const linkType = useSelector(selectedLinkType)
  const {TL_Tax_Plan_Enabled: isNewTLPlanEnabled = false} = useUserFeatures()
  const kickoffCallLabel = getKickoffCallLabelFromCart(structuredCart)
  useEffect(() => {
    async function fetchScheduleOffsetDays() {
      try {
        let scheduleOffsetDetailResponse = await client(
          'cc/order/schedule-offset-days',
        )
        if (scheduleOffsetDetailResponse) {
          setScheduleOffsetDetails(scheduleOffsetDetailResponse)
        }
      } catch (err) {
        console.log('Error while fetch offset schedule details')
      }
    }
    fetchScheduleOffsetDays()
  }, [])

  useEffect(() => {
    if (!structuredCart) return
    let seoProdDetail = structuredCart?.apps.find(item =>
      item?.code.includes('seobase-5-thryv-m2m'),
    )
    setSeoDetail(seoProdDetail)
  }, [structuredCart])

  useEffect(() => {
    SCHEDULE_OPTIONS = []
    if (
      isKickOffCallExist &&
      !SCHEDULE_OPTIONS.find(({name}) => name === 'kickoff')
    ) {
      SCHEDULE_OPTIONS.push({
        name: 'kickoff',
        label: kickoffCallLabel,
      })
    }
    if (
      isCreativeCallExist &&
      !SCHEDULE_OPTIONS.find(({name}) => name === 'creative')
    ) {
      SCHEDULE_OPTIONS.push({name: 'creative', label: 'Website Design Call'})
    }
    if (SCHEDULE_OPTIONS.length > 0) {
      setSelectedCall(SCHEDULE_OPTIONS[0].label)
    }
  }, [isCreativeCallExist, isKickOffCallExist, kickoffCallLabel])

  useEffect(() => {
    dispatch(fetchProductGroups({client}))
  }, [dispatch, client])

  useEffect(() => {
    const scheduleCallDetails =
      selectedCall === kickoffCallLabel
        ? scheduleKickOffCallDetails
        : scheduleCreativeCallDetails

    if (scheduleCallDetails?.isCallScheduled) {
      setSelectedDate(
        dayjs(scheduleCallDetails?.callDetails?.startDateTime).format(
          'YYYY-MM-DD',
        ),
      )
      setSelectedHours(
        dayjs(scheduleCallDetails?.callDetails?.startDateTime).format(
          'YYYY-MM-DD',
        ),
      )
    } else {
      resetCallDetails()
    }

    setAvailableSlotDetails({
      availableTimes: [],
      serviceIdTitle: {},
      timeZone: {},
    })
  }, [
    selectedCall,
    kickoffCallLabel,
    scheduleKickOffCallDetails,
    scheduleCreativeCallDetails,
  ])

  const getMinDate = () => {
    let date = new Date()
    let isCreativeCallTabActive = selectedCall === 'Website Design Call'
    if (
      isCreativeCallTabActive &&
      isKickOffCallExist &&
      scheduleKickOffCallDetails?.isCallScheduled
    ) {
      date = new Date(
        dayjs(scheduleKickOffCallDetails.callDetails.thryvBookingDate).add(
          1,
          'day',
        ),
      )
      return date
    } else if (seoDetail) {
      let offsetDetails = scheduleOffsetDetails.find(
        item => item.product_code === seoDetail.code,
      )
      date = new Date(dayjs().add(offsetDetails?.offset_start_day || 1, 'day'))
      return date
    } else {
      return date
    }
  }

  const getMaxDate = () => {
    let defaultMaxDate = getMinDate()
    let isCreativeCallTabActive = selectedCall === 'Website Design Call'
    let dateAdds = [9, 9, 9, 9, 11, 11, 10]
    if (
      isCreativeCallTabActive &&
      (selectedCountry === 'AU' || selectedCountry === 'NZ')
    ) {
      dateAdds = [16, 16, 16, 16, 18, 18, 17]
    }
    if (seoDetail && !isCreativeCallTabActive) {
      let offsetDetails = scheduleOffsetDetails.find(
        item => item.product_code === seoDetail.code,
      )
      defaultMaxDate = dayjs().add(offsetDetails?.offset_end_day || 1, 'day')
      return defaultMaxDate
    }
    const dayOfWeek = new Date().getDay()
    const extendedDay = dateAdds[dayOfWeek]
    defaultMaxDate = dayjs(defaultMaxDate).add(extendedDay, 'day')
    return new Date(defaultMaxDate)
  }

  function includeAddonsCodes(callType, url) {
    let allCentersAndApps = [...structuredCart.centers, ...structuredCart.apps]
    let ccEntitlements = structuredCart.centers
      .filter(({code}) => !code.startsWith('cc_'))
      .flatMap(item => item.entitlements)
    allCentersAndApps = [...allCentersAndApps, ...ccEntitlements]

    const onboardingAddons = ['HIPAA', ...(addonCodeMap.RestrictedAccess || [])]
    if (callType === 'kickoff') {
      onboardingAddons.push(
        ...(addonCodeMap.ThryvLeads || []),
        ...(addonCodeMap.MarketingCenter || []),
        ...(addonCodeMap.SEO || []),
        ...(addonCodeMap.SocialAds || []),
        ...(addonCodeMap.WorkforceCenter || []),
        ...(addonCodeMap.ThryvSocialPosts || []),
        ...(addonCodeMap.Website || []),
      )
      if (structuredCart)
        onboardingAddons.push(...(addonCodeMap.BusinessCenter || []))
    }

    if (callType === 'creative') {
      if (structuredCart) {
        onboardingAddons.push(
          ...(addonCodeMap.Website || []),
          ...(addonCodeMap.Logo || []),
          ...(addonCodeMap.SEO || []),
        )
      }
    }
    const codes = new Set()
    const addMatchingAddon = code => {
      if (!code) return
      if (onboardingAddons.includes(code)) {
        codes.add(code)
      }
    }
    // allCentersAndApps.map(item => {
    //   if (
    //     item &&
    //     item?.name &&
    //     onboardingAddons.includes(item.name) &&
    //     !item?.included
    //   ) {
    //     codes.push(item.name)
    //   }
    //   return item
    // })

    allCentersAndApps.map(item => {
      if (!item) return item

      addMatchingAddon(item.code)

      if (Array.isArray(item.addons)) {
        item.addons.forEach(addon => {
          addMatchingAddon(addon.code)
        })
      }

      return item
    })

    const existingThryvLeadsSub =
      transitionData?.thryvDetail?.subDetails?.childSubscriptions?.find(
        sub =>
          sub?.plan?.code === NEW_THRYV_LEAD_CODE ||
          sub?.plan?.code === 'tl-5-thryv-m2m',
      )
    const isNewThryvLeadsSale = !existingThryvLeadsSub
    const shouldRemapTL =
      linkType === '1:1' && isNewThryvLeadsSale && isNewTLPlanEnabled
    const resolveOutboundCode = code =>
      shouldRemapTL && code === NEW_THRYV_LEAD_CODE
        ? NEW_THRYV_LEAD_TAX_CODE
        : code
    const codeList = Array.from(codes).map(resolveOutboundCode)

    return codeList.length > 0
      ? `${url}&productGroupCodes=${codeList.join(',')}`
      : url
  }

  function resetCallDetails() {
    setSelectedDate(null)
    setSelectedHours(null)
  }

  function handleTimeZoneChange(timezone) {
    setSelectedTimeZone(
      timeZones.find(item => item.value === timezone.timeZoneId) ||
        DEFAULT_TIMEZONE,
    )
  }

  const renderDateList = () => {
    let dateArray = []
    let currentDate = getMinDate()
    let finalDate = getMaxDate()
    while (currentDate <= finalDate) {
      dateArray.push(dayjs(currentDate).format('YYYY-MM-DD'))
      currentDate = dayjs(currentDate).add(1, 'days')
    }

    let selectedDateStyle = {borderColor: '#5378FC', borderWidth: '2px'}
    let unSelectedDateStyle = {borderColor: '#f3f3f3', borderWidth: '1px'}
    return (
      <div className="d-flex gap-4 cursor-pointer">
        {dateArray.map(item => (
          <div
            key={item}
            id={dayjs(item).format('YYYY-MM-DD')}
            className={
              item === selectedDate
                ? 'active-date-slot px-2 py-2 rounded'
                : 'px-2 py-2 rounded'
            }
            style={
              item === selectedDate ? selectedDateStyle : unSelectedDateStyle
            }
            onClick={async () => {
              setLoadingStatus(true)

              let url
              const callTypes = {
                kickoff: 'Onboarding',
                creative: 'Creative',
                'thryv-success-services': 'ThryvSuccessServices',
              }
              const addressParam = [
                accountInformation.address,
                accountInformation.city,
                accountInformation.state,
              ]
                .filter(Boolean)
                .join(' ')
              url = `cc/order/available-times?appointmentType=${
                selectedCall === kickoffCallLabel
                  ? callTypes['kickoff']
                  : callTypes['creative']
              }&country=${selectedCountry}&address=${encodeURIComponent(
                addressParam,
              )}&languagePreference=en&date=${dayjs(item).format(
                'YYYY-MM-DD',
              )}&keapClientPortalAccount=true`
              url = includeAddonsCodes(
                selectedCall === kickoffCallLabel ? 'kickoff' : 'creative',
                url,
              )
              setSelectedDate(item)
              setSelectedMonth(dayjs(item).format('MMMM[,] YYYY'))
              // const data = await client(url)
              const data = await kP11LinkService.fetchAvailableTimeSlot(
                client,
                url,
              )
              if (data?.warning) {
                toast.warning(data.warning)
              } else {
                if (data?.timeZone) {
                  handleTimeZoneChange(data?.timeZone)
                }
                setAvailableSlotDetails(data)
              }
              setLoadingStatus(false)
              let el = document.getElementById(dayjs(item).format('YYYY-MM-DD'))
              el?.scrollIntoView({
                behavior: 'instant',
                block: 'end',
                inline: 'nearest',
              })
            }}
          >
            <ParagraphText
              variant="reg"
              style={{
                color: 'rgb(205, 205, 205)',
                fontWeight: 'bold',
                fontSize: '0.8rem',
              }}
            >
              {dayjs(item).format('ddd').toUpperCase()}
            </ParagraphText>
            <ParagraphText
              variant="reg"
              style={{
                color: 'black',
                fontWeight: 'bold',
                fontSize: '1.5rem',
              }}
            >
              {dayjs(item).format('DD')}
            </ParagraphText>
          </div>
        ))}
      </div>
    )
  }

  const CalendarViewSection = () => {
    return (
      <div className="pb-4">
        <ParagraphText
          variant="reg"
          style={{
            color: 'black',
            fontWeight: 'bold',
            fontSize: '1rem',
          }}
        >
          {selectedMonth}
        </ParagraphText>
        <div className="d-flex gap-4 ">
          <SolidAltArrowLeft
            height={30}
            width={30}
            style={{marginTop: '40px'}}
            onClick={() => {
              let scrollSlot = document.getElementsByClassName('date-scroll')
              if (currentDateScrollPosition.current !== 0) {
                currentDateScrollPosition.current =
                  currentDateScrollPosition.current - 100
                scrollSlot[0].scrollTo({
                  left: currentDateScrollPosition.current,
                  behavior: 'smooth',
                })
              }
            }}
          />
          <div className="hide-scroll overflow-auto date-scroll">
            {renderDateList()}
          </div>
          <SolidAltArrowRight
            height={30}
            width={30}
            style={{marginTop: '40px'}}
            onClick={() => {
              let scrollSlot = document.getElementsByClassName('date-scroll')
              currentDateScrollPosition.current =
                currentDateScrollPosition.current + 100
              scrollSlot[0].scrollTo({
                left: currentDateScrollPosition.current,
                behavior: 'smooth',
              })
            }}
          />
        </div>
      </div>
    )
  }

  const TimeZoneViewSection = () => {
    return (
      <div className="d-flex  justify-content-end align-items-center py-4">
        {/* <section className="d-flex w-100">
          <Select
            selectLabel="Select Region"
            options={timeZones}
            width="lg"
            selectedOption={selectTimeZone}
            setSelectedOption={setSelectedTimeZone}
            withLabel={selectTimeZone.value}
            className="align-self-stretch w-70"
          />
        </section> */}
        <section
          className={` d-flex  gap-4 ${
            availableSlotDetails?.availableTimes.length < 10 ? 'pe-none' : ''
          }`}
        >
          <SolidAltArrowLeft
            height={20}
            width={20}
            fill={
              availableSlotDetails?.availableTimes.length < 10
                ? 'rgba(0,0,0,0.2)'
                : 'black'
            }
            onClick={() => {
              let scrollSlot = document.getElementsByClassName('slot-scroll')
              if (currentSlotScrollPosition.current !== 0) {
                currentSlotScrollPosition.current =
                  currentSlotScrollPosition.current - 100

                scrollSlot[0].scrollTo({
                  left: currentSlotScrollPosition.current,
                  behavior: 'smooth',
                })
              }
            }}
          />
          <SolidAltArrowRight
            height={20}
            width={20}
            style={{fill: 'white'}}
            fill={
              availableSlotDetails?.availableTimes.length < 10
                ? 'rgba(0,0,0,0.2)'
                : 'black'
            }
            onClick={() => {
              let scrollSlot = document.getElementsByClassName('slot-scroll')
              currentSlotScrollPosition.current =
                currentSlotScrollPosition.current + 100
              scrollSlot[0].scrollTo({
                left: currentSlotScrollPosition.current,
                behavior: 'smooth',
              })
            }}
          />
        </section>
      </div>
    )
  }
  const AvailableSlotViewSection = () => {
    return (
      <div className="w-100 border border-style rounded">
        <div
          className="hide-scroll overflow-x-scroll overflow-y-hidden slot-scroll"
          style={{height: '300px'}}
          ref={slotTargetRef}
        >
          {isLoading ? (
            <Spinner />
          ) : (
            <>
              {availableSlotDetails.availableTimes.length > 0 ? (
                availableSlotDetails.availableTimes.map((item, index) => {
                  return (
                    <div
                      key={index}
                      id={`scroll-slot-row${index}`}
                      className={`d-flex gap-4 my-4 cursor-pointer`}
                    >
                      {availableSlotDetails.availableTimes.map(
                        (subItem, subIndex) => {
                          return subIndex % SCHEDULE_ROW_COUNT === index ? (
                            <div
                              key={subItem.startDateTime}
                              id={subItem.startDateTime}
                              className={
                                (selectedHours === subItem
                                  ? 'active-time-slot'
                                  : '') +
                                ' d-flex justify-content-center px-1.5 py-2 align-items-center'
                              }
                              style={{
                                backgroundColor:
                                  selectedHours === subItem
                                    ? '#5378FC'
                                    : 'white',
                                borderRadius: '5px',
                                border: '1px solid rgba(0,0,0,0.2)',
                              }}
                              onClick={() => {
                                setSelectedHours(subItem)
                                let el = document.getElementById(
                                  `scroll-slot-row${index}`,
                                )
                                el?.scrollIntoView({
                                  behavior: 'instant',
                                  block: 'end',
                                  inline: 'nearest',
                                })
                              }}
                            >
                              <span
                                style={{
                                  textAlign: 'center',
                                  width: SLOT_BTN_WIDTH + 'px',
                                  color:
                                    selectedHours === subItem
                                      ? 'white'
                                      : 'black',
                                }}
                                className={JSON.stringify(subItem)}
                              >
                                {dayjs(subItem.startDateTime)
                                  .tz(
                                    availableSlotDetails?.timeZone?.timeZoneId,
                                  )
                                  .format('h:mm a')}
                              </span>
                            </div>
                          ) : (
                            <></>
                          )
                        },
                      )}
                    </div>
                  )
                })
              ) : (
                <section
                  className={
                    'd-flex justify-content-center align-items-center w-100 h-100'
                  }
                >
                  <ParagraphText variant="lg" className="font-bold text-center">
                    {selectedDate
                      ? !availableSlotDetails?.availableTimes?.length &&
                        'No Slot available please search for some other available dates'
                      : 'Please select days to fetch the available slot for the call scheduling'}
                  </ParagraphText>
                </section>
              )}
            </>
          )}
        </div>
      </div>
    )
  }

  async function cancelAppointment({type, apptId, country}) {
    try {
      const data = {
        type,
        demoApptId: apptId,
        country,
      }
      await client('plans/creative', {data, method: 'DELETE'})
    } catch {
      toast.error('error cancelling creative')
    }
  }

  async function confirmScheduling() {
    try {
      setConfirmationInitiatedStatus(true)
      const apptData = {
        firstName: accountInformation.firstName,
        lastName: accountInformation.lastName,
        email: accountInformation.email,
        phone: accountInformation?.mobile,
        company: accountInformation.company,
        isKeapClientPortalReq: true,
      }
      const scheduleInfo = {
        timeZone: availableSlotDetails.timeZone.timeZoneId,
        serviceId: availableSlotDetails?.serviceIdTitle.serviceId,
        staffId: selectedHours.staffId,
        startTime: selectedHours.startTime,
        thryvBookingDate: selectedHours.startDateTime,
        isAus: selectedCountry === 'AU',
        isNZ: selectedCountry === 'NZ',
        country: selectedCountry,
        isApptHold: true,
      }

      let appointment_type = ''
      let existingApptId = ''
      if (selectedCall === 'Website Design Call') {
        appointment_type = 'creative'
        apptData['creative'] = scheduleInfo
        if (scheduleCreativeCallDetails?.isCallScheduled) {
          existingApptId = scheduleCreativeCallDetails.callDetails.apptId
        }
      } else {
        apptData['onboarding'] = scheduleInfo
        appointment_type = 'onboarding'
        if (scheduleKickOffCallDetails?.isCallScheduled) {
          existingApptId = scheduleKickOffCallDetails.callDetails.apptId
        }
      }
      if (scheduleKickOffCallDetails?.callDetails?.skip) {
        setScheduledCreativeCallDetails(null)
      } else {
        const {apptId} = await kP11LinkService.confirmScheduleSlot(
          client,
          `plans/${appointment_type}`,
          apptData,
        )
        // const apptId = '1112424234'
        if (apptId) {
          apptData.appointment_type = appointment_type
        }
        if (appointment_type === 'onboarding') {
          setScheduledKickOffCallDetails({
            isCallScheduled: true,
            callDetails: {
              ...apptData[`${appointment_type}`],
              appointment_type,
              apptId,
            },
          })
          if (scheduleCreativeCallDetails?.isCallScheduled) {
            setScheduledCreativeCallDetails(null)
          }
        } else {
          setScheduledCreativeCallDetails({
            isCallScheduled: true,
            callDetails: {
              ...apptData[`${appointment_type}`],
              appointment_type,
              apptId,
            },
          })
        }
      }

      if (existingApptId) {
        await cancelAppointment({
          type: appointment_type,
          country: selectedCountry,
          apptId: existingApptId,
        })
      }

      setConfirmationInitiatedStatus(false)
      if (appointment_type === 'onboarding') {
        if (SCHEDULE_OPTIONS.length > 1) {
          setSelectedCall(SCHEDULE_OPTIONS[1].label)
        } else {
          handleScheduleSuccessStatus()
        }
      } else {
        handleScheduleSuccessStatus()
      }
      toast.success(`${selectedCall}  confirmed`)
    } catch (err) {
      setConfirmationInitiatedStatus(false)
      if (err.status !== 400) {
        throw err
      }
      err.errors.forEach(({message}) => toast.error(message))
    }
  }

  const selectedTabs = {
    border: '1px solid #5378FC',
    borderBottom: '0px',
    borderRadius: '5px 5px 0px 0px',
    padding: '5px 10px',
    marginBottom: '-1px',
    backgroundColor: '#5378FC',
    color: 'white',
  }

  const unSelectedTabs = {
    border: '1px solid transparent',
    padding: '5px 10px',
    backgroundColor: 'white',
  }

  // const handleScheduleValidationCheck = () => {
  //   if (isKickOffCallExist && !scheduleKickOffCallDetails?.isCallScheduled) {
  //     toast.error('Please schedule a kickoff Call in order proceed further')
  //     return
  //   }
  //   if (isCreativeCallExist && !scheduleCreativeCallDetails?.isCallScheduled) {
  //     toast.error('Please schedule a creative call in order to proceed further')
  //     return
  //   }
  //   handleScheduleSuccessStatus()
  // }

  const renderScheduleSection = () => {
    return (
      <div className={`col align-self-start mt-4`}>
        <CalendarViewSection />
        <TimeZoneViewSection />
        <AvailableSlotViewSection />
        {selectedCall === 'Website Design Call' &&
          isCreativeCallExist &&
          isKickOffCallExist &&
          !scheduleKickOffCallDetails?.isCallScheduled && (
            <section
              className="position-absolute w-100 h-100 fixed-top"
              style={{background: 'white'}}
            >
              <section className="d-flex align-items-center w-100 h-100 text-center">
                <p className="w-100 text-center">
                  Please schedule Kickoff Call before scheduling Creative Call{' '}
                </p>
              </section>
            </section>
          )}
      </div>
    )
  }

  const handleConfirmDisabledCheck = () => {
    let nonSelectedOption = !(selectedDate && selectedHours)
    if (selectedCall === kickoffCallLabel) {
      if (scheduleKickOffCallDetails?.isCallScheduled) {
        if (
          scheduleKickOffCallDetails?.callDetails?.thryvBookingDate ===
          selectedHours?.startDateTime
        ) {
          return true
        } else {
          return false
        }
      } else {
        return nonSelectedOption
      }
    }
    if (selectedCall === 'Website Design Call') {
      if (scheduleCreativeCallDetails?.isCallScheduled) {
        if (
          scheduleCreativeCallDetails?.callDetails?.thryvBookingDate ===
          selectedHours?.startDateTime
        ) {
          return true
        } else {
          return false
        }
      } else {
        return nonSelectedOption
      }
    }
    return nonSelectedOption
  }

  const isWorkforceCenterInCart = () => {
    let allCentersAndApps = [...structuredCart.centers, ...structuredCart.apps]

    // Check if Workforce Center Plus is in the cart
    const hasWorkforceCenter = allCentersAndApps.some(item =>
      item?.name?.includes('Workforce Center'),
    )

    // Also check in nested addons
    const hasWorkforceCenterInAddons = allCentersAndApps.some(item =>
      item?.addons?.some(addon => addon?.name?.includes('Workforce Center')),
    )

    // Products that require scheduling appointments
    const productsRequiringScheduling = [
      'Thryv Leads',
      'Marketing Center',
      'SEO Money Back Guarantee',
      'SEO Non-Guaranteed',
      'AEO & SEO',
      'Social Ads',
      'Thryv HVAC',
      'Business Center',
      'Custom Video',
      'Professionally Designed Website',
    ]

    // Check if any other product requiring scheduling is in cart
    const hasOtherSchedulingProducts = allCentersAndApps.some(item => {
      // Check main item
      if (
        item?.name &&
        productsRequiringScheduling.some(
          product => item.name.includes(product) && !item.included,
        )
      ) {
        return true
      }

      // Check nested addons
      if (Array.isArray(item?.addons)) {
        return item.addons.some(
          addon =>
            addon?.name &&
            productsRequiringScheduling.some(
              product => addon.name.includes(product) && !addon.included,
            ),
        )
      }

      return false
    })

    // Show skip only if Workforce Center is in cart AND no other scheduling products
    return (
      (hasWorkforceCenter || hasWorkforceCenterInAddons) &&
      !hasOtherSchedulingProducts
    )
  }

  console.log({selectTimeZone})
  return (
    <>
      <div className="w-100 d-flex">
        <div className="w-40 d-flex mt-4">
          <section>
            <section className="d-flex gap-1 align-items-center">
              <Icon
                type="regular"
                variant="calendarClock"
                color="gray"
                height="20"
                width="20"
              />
              <span>30 minutes</span>
            </section>
            <section className="d-flex gap-1 align-items-center">
              <Icon
                type="regular"
                variant="globe"
                color="gray"
                height="20"
                width="20"
              />
              <span>
                {selectTimeZone &&
                  dayjs().tz(selectTimeZone.value).format('zzz')}
              </span>
            </section>
            <br />
            <strong>
              Select a date & time for your upcoming appointments. Time zone
              will update once date is selected.
            </strong>
          </section>
        </div>
        <div className="w-60 border-left-style">
          <div className="d-flex border-bottom w-100">
            {SCHEDULE_OPTIONS.map(item => (
              <span
                style={
                  item?.label === selectedCall ? selectedTabs : unSelectedTabs
                }
                className="cursor-pointer"
                key={item?.label}
                onClick={() => {
                  setSelectedCall(item?.label)
                }}
              >
                {item?.label}
              </span>
            ))}
          </div>
          {renderScheduleSection()}
          <div
            className="d-flex col align-self-end justify-content-end gap-4 mt-2"
            style={{height: '30px'}}
          >
            {isWorkforceCenterInCart() && handleSkipScheduling && (
              <Button
                variant="secondary"
                style={{borderRadius: '20px!important'}}
                onClick={handleSkipScheduling}
              >
                Skip for Now
              </Button>
            )}
            <Button
              variant="primary"
              style={{borderRadius: '20px!important'}}
              onClick={confirmScheduling}
              disabled={handleConfirmDisabledCheck()}
            >
              Confirm
            </Button>
            {/* {((selectedMonth &&
              selectedHours &&
              isKickOffCallExist &&
              scheduleKickOffCallDetails?.isCallScheduled) ||
              (selectedMonth &&
                selectedHours &&
                isCreativeCallExist &&
                scheduleCreativeCallDetails?.isCallScheduled)) && (
              <Button
                variant="primary"
                style={{borderRadius: '20px'}}
                onClick={handleScheduleValidationCheck}
              >
                Continue
              </Button>
            )} */}
          </div>
        </div>
      </div>

      {isConfirmationInitiated && (
        <div
          style={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: '0px',
            left: '0px',
            background: 'rgba(0, 0, 0, 0.3)',
          }}
        >
          <div className="d-flex justify-content-between align-items-center h-100">
            <Spinner />
          </div>
        </div>
      )}
    </>
  )
}
